import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LayoutStateProps, SidebarMenuItem } from "../../../Types/Layout.type";
import { fetchResource } from "../../../hook/request";

export const fetchMenu = createAsyncThunk<
    SidebarMenuItem[],
    void,
    { rejectValue: string }
>(
    "layout/fetchMenu",
    async (_, { rejectWithValue }) => {
        try {
            const email = localStorage.getItem("email");
            if (!email) {
                return rejectWithValue("Email non trovata nel localStorage");
            }
            const ipRes = await fetch("https://api.ipify.org?format=json");
            const ipJson = await ipRes.json();
            const ip = ipJson.ip;
            const response = await fetchResource<SidebarMenuItem>("/data/menu", {
                user_email: email,
                user_ip: ip,      
            });

            return Array.isArray(response) ? response : [response];

        } catch (error: any) {
            return rejectWithValue(error.message || "Errore nel caricamento del menu");
        }
    }
);


interface ExtendedLayoutStateProps extends LayoutStateProps {
    menuList: SidebarMenuItem[];
    menuLoading: boolean;
    menuError: string | null;
}

const initialState: ExtendedLayoutStateProps = {
    responsiveSearch: false,
    pinedMenu: [],
    sideBarToggle: false,
    isSearchBarOpen: false,
    menuList: [],
    menuLoading: false,
    menuError: null,
};

const LayoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {
        setIsSearchBarOpen: (state, action) => {
            state.isSearchBarOpen = action.payload;
        },
        setResponsiveSearch: (state) => {
            state.responsiveSearch = !state.responsiveSearch;
        },
        setPinedMenu: (state, action) => {
            state.pinedMenu = action.payload;
        },
        setSideBarToggle: (state, action) => {
            state.sideBarToggle = action.payload;
        },
        handlePined: (state, action) => {
            if (action.payload) {
                if (state.pinedMenu.includes(action.payload)) {
                    let filterMenu = state.pinedMenu.filter((item) => item !== action.payload);
                    state.pinedMenu = filterMenu;
                } else {
                    state.pinedMenu = [...state.pinedMenu, action.payload];
                }
            }
        },
        resetMenu: (state) => {
            state.menuList = [];
            state.menuLoading = false;
            state.menuError = null;
            state.pinedMenu = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenu.pending, (state) => {
                state.menuLoading = true;
                state.menuError = null;
            })
            .addCase(fetchMenu.fulfilled, (state, action) => {
                state.menuLoading = false;
                state.menuList = action.payload;
                state.menuError = null;
            })
            .addCase(fetchMenu.rejected, (state, action) => {
                state.menuLoading = false;
                state.menuError = action.payload || "Errore sconosciuto";
            });
    },
});
export const { setResponsiveSearch,setIsSearchBarOpen, setPinedMenu, setSideBarToggle, handlePined, resetMenu } = LayoutSlice.actions;
export default LayoutSlice.reducer;
